import { ArrowBackIosNewOutlined, Dashboard, MenuOutlined, Settings } from "@mui/icons-material";
import { Box, Tooltip, Typography } from "@mui/material";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import LocationCityRoundedIcon from "@mui/icons-material/LocationCityRounded";
import ExitToAppRoundedIcon from "@mui/icons-material/ExitToAppRounded";
import AddBusinessRoundedIcon from "@mui/icons-material/AddBusinessRounded";
import PrecisionManufacturingRoundedIcon from '@mui/icons-material/PrecisionManufacturingRounded';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import LeaderboardRoundedIcon from '@mui/icons-material/LeaderboardRounded';
import PunchClockIcon from '@mui/icons-material/PunchClock';
import QrCodeScannerRoundedIcon from '@mui/icons-material/QrCodeScannerRounded';
import { BiSolidReport } from "react-icons/bi";
import React, { useState } from "react";
import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { useNavigate } from "react-router-dom";
import useAuth from "../customHooks/useAuth";
const Items = ({ label, icon, onClickAction, active }) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <Tooltip title={label} placement="right-start">
      <div>
        <MenuItem
          active={active}
          style={{
            // color: color,
            marginTop: 2,
            background: active ? "#08086b" : isHovered ? "#08086b" : "#ffffff", // Change background color on hover
            color: active ? "#ffffff" : isHovered ? "#ffffff" : "#08086b",
            borderStartStartRadius: 20,
            borderEndStartRadius: 20,
            marginTop: active ? "0.2em" : isHovered ? "0.2em" : "0.2em",
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          icon={icon}
          onClick={onClickAction}
        >
          <Typography sx={{ fontSize: 16, fontFamily: "inherit" }}>{label}</Typography>
        </MenuItem>
      </div>
    </Tooltip>
  );
};
const SideBarComponent = () => {
  const { role_id, company_id } = useAuth()
  // console.log("role_id==>", role_id)
  // const dispatch = useDispatch();
  const [show, setHide] = useState(false);
  const [activeItem, setActiveItem] = useState("");
  const navigate = useNavigate();


  const handleNavigation = (path) => {
    navigate(path);
    setActiveItem(path); // Update the active item when navigating
  };

  const logOutHandler = () => {
    localStorage.clear("workManagement")
    navigate("/");
  };
  return (
    <>
      <Box>
        <Sidebar
          collapsed={show}
          transitionDuration={500}
          width="16em"
          backgroundColor={"white"}
          rootStyles={{
            height: "100vh",
            // boxShadow: "0 3px 3em #f0f0f0",
          }}
        >
          {!show && (
            <Box
              sx={{
                textAlign: "right",
                p: 1,
                cursor: "pointer",
                position: "sticky",
                top: "0em",
                bgcolor: "white",
                zIndex: 99
              }}
            >
              <ArrowBackIosNewOutlined style={{ color: "#08086b" }} onClick={() => setHide(true)} />
            </Box>
          )}
          {show && (
            <Box
              sx={{
                textAlign: "center",
                p: 1,
                cursor: "pointer",
                position: "sticky",
                top: "0em",
                bgcolor: "white",
              }}
            >
              <MenuOutlined style={{ color: "#08086b" }} onClick={() => setHide(false)} />
            </Box>
          )}
          {!show && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                gap: "2em",
                p: 1,
                position: "sticky",
                top: "2.7em",
                bottom: "2em",
                zIndex: 99,
                bgcolor: "white",
                marginBottom: "1.5em",
              }}
            >
              <img
                src={'/magod_logo.png'} alt="L"
                style={{ width: "auto", height: 90, mt: "-2em", objectFit: "fill" }}
              />
            </Box>
          )}
          <Menu closeOnClick transitionDuration={500}>
            {(role_id === 3000) &&
              (<Items label={'Dashboard'} icon={<Dashboard size={25} />} color={"black"} onClickAction={() => handleNavigation('/magod/CompanyDashboard')} active={activeItem === '/magod/CompanyDashboard'} />
              )}
            {(role_id === 4000 || role_id === 5000 || role_id === 6000) &&
              (<Items label={'Dashboard'} icon={<Dashboard size={25} />} color={"black"} onClickAction={() => handleNavigation('/magod/UnitDashBoard')} active={activeItem === '/magod/UnitDashBoard'} />
              )}
            {(role_id === 2000) &&
              (<Items label={'Dashboard'} icon={<Dashboard size={25} />} color={"black"} onClickAction={() => handleNavigation('/magod/SuperAdminDashboard')} active={activeItem === '/magod/SuperAdminDashboard'} />
              )}
            <Items
              label={"Manage Work Track"}
              icon={<LeaderboardRoundedIcon size={25} />}
              color={"black"}
              onClickAction={() =>
                handleNavigation("/magod/manageWorkTrack")
              }
              active={activeItem === "/magod/manageWorkTrack"}
            />
            {(role_id !== 5000) && (
              <Items
                label={"Upload Work Orders"}
                icon={<WorkHistoryIcon size={25} />}
                color={"black"}
                onClickAction={() =>
                  handleNavigation("/magod/ManageWork")
                }
                active={activeItem === "/magod/ManageWork"}
              />
            )}
            {(company_id !== 11 && role_id !== 5000) && (
              <Items
                label={"Manage Punch In/Out"}
                icon={<PunchClockIcon size={25} />}
                color={"black"}
                onClickAction={() =>
                  handleNavigation("/magod/managePunchInOut")
                }
                active={activeItem === "/magod/managePunchInOut"}
              />
            )}
            {(role_id !== 5000) && (
              <Items
                label={"Print QR(Work-Order)"}
                icon={<QrCodeScannerRoundedIcon size={25} />}
                color={"black"}
                onClickAction={() => handleNavigation("/magod/managePrintQR")}
                active={activeItem === "/magod/managePrintQR"}
              />
            )}
            {(role_id !== 5000) && (
              <Items
                label={"WorkOrder Report"}
                icon={<BiSolidReport size={25} />}
                color={"black"}
                onClickAction={() => handleNavigation("/magod/manageReport")}
                active={activeItem === "/magod/manageReport"}
              />
            )}
            {(role_id !== 6000) && (
              <SubMenu
                icon={<Settings />}
                style={{ color: "#08086b", fontWeight: "bold" }}
                label="Setups"
              >
                <Box>
                  <Items
                    label={"Manage Employees"}
                    icon={<PeopleRoundedIcon size={25} />}
                    color={"black"}
                    onClickAction={() => handleNavigation("/magod/manageUser")}
                    active={activeItem === "/magod/manageUser"}
                  />
                  {(role_id !== 5000) && (
                    <Items
                      label={"Manage Company"}
                      icon={<LocationCityRoundedIcon size={25} />}
                      color={"black"}
                      onClickAction={() =>
                        handleNavigation("/magod/manageCompany")
                      }
                      active={activeItem === "/magod/manageCompany"}
                    />
                  )}
                  {(role_id !== 5000) && (
                    <Items
                      label={"Manage Units"}
                      icon={<AddBusinessRoundedIcon size={25} />}
                      color={"black"}
                      onClickAction={() =>
                        handleNavigation("/magod/manageDepartment")
                      }
                      active={activeItem === "/magod/manageDepartment"}
                    />
                  )}
                  {(role_id !== 5000) && (
                    <Items
                      label={"Manage Machines"}
                      icon={<PrecisionManufacturingRoundedIcon size={25} />}
                      color={"black"}
                      onClickAction={() =>
                        handleNavigation("/magod/manageMachine")
                      }
                      active={activeItem === "/magod/manageMachine"}
                    />
                  )}
                </Box>
              </SubMenu>
            )}
            <Items
              label={"Log Out"}
              icon={<ExitToAppRoundedIcon size={25} />}
              color={"black"}
              onClickAction={() => logOutHandler()}
            />
          </Menu>
          {!show && (
            <Box sx={{ position: { xs: "fixed" }, display: "flex", justifyContent: "center", alignItems: "center", bottom: "1em", left: { sm: "2%" }, px: { xs: "1em", xl: 0 }, zIndex: -999 }}>
              <Typography
                sx={{
                  fontSize: "0.7em",
                  color: "black",
                  fontWeight: "bold",
                }}
                variant="body1"
              >
                Powered by
                <a
                  href="https://www.ganakalabs.com/"
                  target="_rebel"
                  style={{ color: "blue" }}
                >
                  {" "}
                  ganakalabs.com
                </a>
              </Typography>
            </Box>
          )}
        </Sidebar>
      </Box>
    </>
  );
};

export default SideBarComponent;
